export const QA_NAME_CALENDAR_RELIEVE_DAY_BUTTON = 'calendarRelieveDay'
